import type { Organization } from '../types/organization';

type FormatZonedDate = (date: string) => { text: string };

const parseDate = (value?: string | null): Date | null => {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
};

export const getOrganizationStatusMessage = (org: Organization, formatZonedDate: FormatZonedDate): string => {
  let message = '';
  const now = new Date();

  const futureDisableDate = parseDate(org.future_disable_date);
  const accessDisableDate = parseDate(org.access_disable_date);

  if (org.status === 'disabled' && !org.future_disable_date) {
    message = 'This store is disabled.';
  } else if (futureDisableDate && futureDisableDate > now) {
    message = 'This store will disable on ' + formatZonedDate(org.future_disable_date as string).text + '.';
  } else if (org.status === 'disabled' && futureDisableDate && futureDisableDate <= now) {
    message = 'The store is disabled as of ' + formatZonedDate(org.future_disable_date as string).text + '.';
  }

  if (accessDisableDate && accessDisableDate > now) {
    message += ' Access will disable on ' + formatZonedDate(org.access_disable_date as string).text + '.';
  } else if (accessDisableDate && accessDisableDate <= now) {
    message += ' Access is disabled as of ' + formatZonedDate(org.access_disable_date as string).text + '.';
  }

  return message.trim();
};

export const hasOrganizationLatePayment = (org: Organization): boolean => {
  return Array.isArray(org.tags) && org.tags.includes('late_payment');
};

export const isOrganizationAccessDisabled = (org: Organization, now = new Date()): boolean => {
  const accessDisableDate = parseDate(org.access_disable_date);
  return Boolean(accessDisableDate && accessDisableDate <= now);
};
